import { getToken, logout, getOrganizationId } from "./AuthService";
import {
  INVALID_TOKEN_MESSAGE,
  API_FAILURE_STATUS,
  restUrl,
} from "../../Constants";

export async function post(api, postBody, appState, sectionId, files) {
  const companyId = appState?.companyId;
  const apiUrl = restUrl + api;
  const requestMetadata = {
    method: "POST",
    credentials: "same-origin",
  };

  const token = getToken();
  const formData = new FormData();

  if (token) {
    formData.append("Authorization", token);
  }

  if (postBody) {
    if (companyId) {
      postBody["companyId"] = parseInt(companyId);
    }
    if (sectionId) {
      postBody["sectionId"] = parseInt(sectionId);
    }

    // Append all postBody fields to FormData
    Object.keys(postBody).forEach((key) => {
      const value = postBody[key];

      // Check if the value is an object (excluding null)
      if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value)); // Convert object to JSON string
      } else {
        formData.append(key, value);
      }
    });
  }

  if (files) {
    Object.keys(files).forEach((key) => {
      formData.append(key, files[key]);
    });
  }

  requestMetadata["body"] = formData;

  const response = await fetch(apiUrl, requestMetadata);
  const data = await response.json();

  if (
    data.status === API_FAILURE_STATUS &&
    data.result === INVALID_TOKEN_MESSAGE
  ) {
    alert("Session expired. Please login again.");
    logout();
  } else {
    return data;
  }
}

export function buildGetURL(api, p) {
  let apiUrl = restUrl + api;

  var token = getToken();
  if (token) {
    apiUrl = apiUrl + "?Authorization=" + token;
  }
  let orgid = getOrganizationId();
  if (orgid) {
    apiUrl = apiUrl + "&organizationId=" + orgid;
  }
  if (p) {
    apiUrl = apiUrl + p;
  }
  return apiUrl;
}

export async function get(api, params = "", additionalHeaders = {}) {
  const token = getToken();
  let apiUrl = `${restUrl}${api}?Authorization=${token}`;

  if (params) {
    apiUrl += `&${params}`;
  }

  const requestMetadata = {
    method: "get",
    credentials: "same-origin",
  };

  try {
    const response = await fetch(apiUrl, requestMetadata);
    const data = await response.json();

    if (
      data.status === API_FAILURE_STATUS &&
      data.result === INVALID_TOKEN_MESSAGE
    ) {
      alert("Session expired. Please login again.");
      logout();
    } else {
      return data;
    }
  } catch (error) {
    console.error("Error making GET request:", error);
    throw error;
  }
}

// RewriteEngine on
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteRule ^(.*)$ page.php?p=$1 [QSA]
